import mediaQuery from './match-media';

function gutenbergTweaks() {

    const contentContainer = document.querySelector('.l-content');

    if(!contentContainer) {
        return;
    }

  	const article = 	document.querySelector('.l-content__article');
  	const blockCover = 	document.querySelector('.wp-block-cover');
    const blockCoverIsFull = blockCover && blockCover.classList.contains('alignfull');
    const windowWidth = document.body.offsetWidth;
    const contentWidth = contentContainer.clientWidth;

    if(article && blockCover && article.firstElementChild == blockCover) {
        if(! mediaQuery('medium').matches)  {
            return;
        }

    	  const paddingTop = blockCover.offsetHeight + 32;
    	  const sidebar1   = document.querySelector('.lf-sidebar-1');
    	  const sidebar2   = document.querySelector('.lf-sidebar-2');
    	  const aside      = document.querySelector('.lf-content-aside');
        const asideIsLeft = !! document.querySelector('[data-aside="left"]');

        if(blockCoverIsFull) {
            blockCover.style.position = 'absolute';
            blockCover.style.width = `100vw`;
            article.style.paddingTop = `${paddingTop}px`;
        }

        if( document.querySelector('.logged-in') ) {

        }

    	  if(sidebar1){
    		    sidebar1.style.paddingTop = `${paddingTop}px`;
    		}

    		if(sidebar2) {
    		    sidebar2.style.paddingTop = `${paddingTop}px`;

    		}

    		if(aside) {
      			aside.style.paddingTop = `${paddingTop}px`;

            if(blockCoverIsFull) {
                let margin = (windowWidth * -.5) + (contentWidth/2);

                if(asideIsLeft) {

                }

                blockCover.style.position == 'absolute';
                blockCover.style.marginLeft = `${margin}px`;
                blockCover.style.marginRight = `${margin}px`; //`${margin}px`;
            }
    		}
  	}

/*    const zoom = mediumZoom('.wp-block-gallery img', {
   background: 'rgba(0, 0, 0, 0.9)',
   template: '#template-facebook',
   container: '[data-zoom-container]'
 });

 // You can start manipulating the DOM after the \`opened\` event has been triggered
 zoom.on('opened', () => {
   const closeButton = document.querySelector('[data-zoom-close]');
   closeButton.addEventListener('click', () => zoom.close());
 });

 // Block scroll on zoom
 zoom.on('open', () => {
   document.body.style.overflow = 'hidden';
 });

 zoom.on('close', () => {
   document.body.style.overflow = '';
 }); */
}

export default gutenbergTweaks;
